import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getMessageProps } from 'Store/reducers';

const ConnectedFormattedImage = props => {
  const { intl, altId, dispatch, ...passedProps } = props;
  return <img {...passedProps} />;
};

const mapStateToProps = (state, { intl, altId }) => {
  const messages = {};
  if (altId) messages.alt = intl.formatMessage(getMessageProps(state, altId));
  return { ...messages };
};

export default injectIntl(connect(mapStateToProps)(ConnectedFormattedImage));
